import { FC } from 'react';
import { FormCheck } from 'react-bootstrap';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import Skeleton from 'components/base/Skeleton';
import ErrorBox from 'components/ErrorBox';
import FormGroup from 'components/FormGroup';
import { useGetIdTypeInfo } from 'components/forms/IdType';
import WeakNetPrompt from 'components/forms/WeakNetPrompt';
import type { FormCheckNumberType } from 'types/common';
import { CustomerInfoKeyType, IdTypeEnum } from 'types/customer';

export interface SameResidenceAddrFormutil {
    same_residence_addr: FormCheckNumberType;
}
export const defaultFieldsOfSameResidenceAddr: CustomerInfoKeyType[] = ['same_residence_addr'];

interface SameResidenceAddrProps {
    $formutil: $Formutil<SameResidenceAddrFormutil>;
    legalResidenceCountry: string;
    issueCountry: string;
    idType: IdTypeEnum;
    disabled?: boolean;
}

const SameResidenceAddr: FC<SameResidenceAddrProps> = props => {
    const { disabled, legalResidenceCountry, idType, issueCountry } = props;
    const { data, error, isLoading, mutate } = useGetIdTypeInfo({ idType, issueCountry });
    // 展示条件：居住国与证件签发国一致 且 证件上有地址信息
    const showSameResidenceAddr = legalResidenceCountry === issueCountry && data?.has_address === 1;

    if (error) {
        return (
            <div className="mb-3">
                <ErrorBox error={error} onClick={() => mutate()} />
                {/* loading/error状态下不能直接提交,需要拦截一下 */}
                <WeakNetPrompt name="temporary_same_residence_addr" type="error" />
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="mb-3">
                <Skeleton line={2} />
                {/* loading状态下不能直接提交,需要拦截一下 */}
                <WeakNetPrompt name="temporary_same_residence_addr" type="loading" />
            </div>
        );
    }

    return showSameResidenceAddr ? (
        <FormGroup<FormCheckNumberType> name="same_residence_addr" checked={1} unchecked={0} $defaultValue={0}>
            <FormCheck
                type="checkbox"
                label={__('居住地址与身份证上的地址一致')}
                id="same_residence_addr"
                disabled={disabled}
            />
        </FormGroup>
    ) : null;
};

export default connect(SameResidenceAddr);
